export default "__VITE_ASSET__CdyHfWi3__"